// extracted by mini-css-extract-plugin
export default {"wrapper":"Currency_wrapper__aUZxw","currency":"Currency_currency__Lg-yG","blockchain":"Currency_blockchain__oegb0"};